import React from 'react';
import {
  Column,
  DropdownButtonCell,
  DropdownButtonCellComponentProps,
  DropdownButtonSkeleton,
  getFixedWidthFaIcon,
} from '@odin-labs/components';
import { faTrash, faWrench } from 'components/icons';
import { EditableJobsiteForm } from 'containers/jobsiteConfiguration/components/jobsiteForms/modals';

export type JobsiteFormColumn = Column<EditableJobsiteForm>;

const WrenchIcon = getFixedWidthFaIcon({ icon: faWrench });
const TrashIcon = getFixedWidthFaIcon({ icon: faTrash });

export const getColumns = ({
  openEditModal,
  openDeleteModal,
}: {
  openEditModal: (jobsiteForm: EditableJobsiteForm) => void;
  openDeleteModal: (jobsiteForm: EditableJobsiteForm) => void;
}): JobsiteFormColumn[] => [
  {
    id: 'name',
    Header: 'Log',
    accessor: (jobsiteForm: EditableJobsiteForm): string =>
      jobsiteForm.form?.label ?? '',
  },
  {
    id: 'sessionAssignment',
    Header: 'Session Assignment',
    accessor: (jobsiteForm: EditableJobsiteForm): string =>
      jobsiteForm.sessionAssignment?.label ?? '—',
  },
  {
    id: 'actions',
    Header: '',
    Cell: DropdownButtonCell,
    CellLoading: (): React.ReactElement => (
      <DropdownButtonSkeleton cellAlignment="right" />
    ),
    componentProps: (
      jobsiteForm: EditableJobsiteForm,
    ): DropdownButtonCellComponentProps => ({
      cellAlignment: 'right',
      menuItems: [
        [
          {
            icon: WrenchIcon,
            text: 'Edit Log',
            theme: 'secondary',
            onClick: (): void => openEditModal(jobsiteForm),
          },
          {
            icon: TrashIcon,
            text: 'Delete Log',
            theme: 'danger',
            onClick: (): void => openDeleteModal(jobsiteForm),
          },
        ],
      ],
    }),
  },
];
